import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import './index-f96168ba.js';
import Button from './Button.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  > ", ":first-child {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n\n    border-right: ", " solid\n      ", ";\n  }\n\n  > ", ":last-child {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  > ", ":not(:first-child):not(:last-child) {\n    border-radius: 0;\n\n    border-right: ", " solid\n      ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledButtonGroup = styled.div(_templateObject(), Button, function (_ref) {
  var theme = _ref.theme;
  return theme.components.buttonGroup.borders.borderWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.buttonGroup.colors.border;
}, Button, Button, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.buttonGroup.borders.borderWidth;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.buttonGroup.colors.border;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Simple Button.
 *
 */

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(StyledButtonGroup, rest, children);
};

ButtonGroup.propTypes = {
  /**
   * The Buttons that will be grouped.
   */
  children: PropTypes.any.isRequired
};
/** @component */

var index = styled(ButtonGroup)(_templateObject$1());

export default index;
